import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ClientAppointmentsTable } from '../../../infrastructure/shared/components/client-appointments-table/client-appointments-table';
import {
  ButtonComponent,
  ButtonSeverity,
  ButtonSize,
} from '../../../infrastructure/shared/ui/button/button';
import { Cube01 } from '../../../infrastructure/shared/icons/cube-01/cube-01';
import { Clock } from '../../../infrastructure/shared/icons/clock/clock';
import { Calendar } from '../../../infrastructure/shared/icons/calendar/calendar';
import { Hourglas03 } from '../../../infrastructure/shared/icons/hourglas-03/hourglas-03';
import { ArrowUpRight } from '../../../infrastructure/shared/icons/arrow-up-right/arrow-up-right';
import { XClose } from '../../../infrastructure/shared/icons/x-close/x-close';
import { UserService } from '../../../infrastructure/shared/services/user.service';
import { ClientPackageStateService } from '../../../infrastructure/shared/services/client-package-state.service';
import { LocationIndividualService } from '../../../infrastructure/shared/services/location-individual.service';
import { getDateFormatedSrLong } from '../../../infrastructure/shared/services/date.service';

@Component({
  standalone: true,
  selector: 'app-individual-appointments-page',
  imports: [
    ClientAppointmentsTable,
    ButtonComponent,
    Cube01,
    Clock,
    Calendar,
    Hourglas03,
    ArrowUpRight,
    XClose,
  ],
  templateUrl: './individual-appointments-page.html',
  styleUrl: './individual-appointments-page.scss',
})
export class IndividualAppointmentsPage {
  private _user = inject(UserService);
  private _router = inject(Router);
  private _locationIndividual = inject(LocationIndividualService);
  protected packageState = inject(ClientPackageStateService);

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  userId = this._user.getUserData.id;
  firstName = this._user.getUserData.fullName?.split(' ')[0] ?? '';
  todayLabel = getDateFormatedSrLong(new Date());

  bannerDismissed = signal(false);

  showOnboardingBanner = computed(
    () =>
      !this.bannerDismissed() &&
      this.packageState.loaded() &&
      !this.packageState.hasActivePackage(),
  );

  canBook = computed(() => this.packageState.canBook());

  constructor() {
    this.packageState.load();
  }

  dismissBanner(): void {
    this.bannerDismissed.set(true);
  }

  goToOffer(): void {
    this._router.navigate(['/individual/packages/offer']);
  }

  goToCreateAppointment(): void {
    this._locationIndividual.routeToCreateAppointment();
  }

  goToCalendar(): void {
    this._locationIndividual.routeToCalendar();
  }
}
